/**
 * Demo-seed kill-switch helper for the onboarding quick-action chips.
 *
 * When the demo-seed feature is unavailable (server kill-switch:
 * config.demoSeedEnabled off → /demo-seed/status 404 → useDemoMode().available
 * === false), the agent-emitted `demo.load` / `demo.switch-to-real` chips must
 * not render — otherwise the user sees a dead button that 404s on click. Pure +
 * generic so it is unit-testable without mounting ChatBox.
 */
export function filterDemoQuickActions<T extends { kind?: string }>(
  actions: T[],
  demoAvailable: boolean,
): T[] {
  if (demoAvailable) return actions;
  return actions.filter((a) => !a.kind?.startsWith('demo.'));
}
